interface ServiceLike {
  title: string;
}

export const sortServicesForNavigation = <T extends ServiceLike>(services: T[]): T[] =>
  [...services].sort((a, b) => {
    const aIsWorkflow = a.title.toLowerCase().includes('workflow automations');
    const bIsWorkflow = b.title.toLowerCase().includes('workflow automations');

    if (aIsWorkflow && !bIsWorkflow) return -1;
    if (!aIsWorkflow && bIsWorkflow) return 1;
    return 0;
  });
